import React, { useContext } from "react";
import { Helmet } from "react-helmet-async";
import { ApplicationContext } from "@context/ApplicationContext";
import AboutUsContent from "@components/AboutUsContent";
import VersionedLayout from "@components/Wrappers/VersionedLayout/index.js";

const AboutUsPage = () => {
    const { whiteLabel } = useContext(ApplicationContext);
    const brand = whiteLabel?.brand_name;

    return (
        <VersionedLayout>
            <Helmet>
                <title>{ `About Us | Our Story | ${brand}` }</title>
                <meta name="keywords" content={ `About Us | Our Story | ${brand}` } />
                <meta name="description" content={ `Discover who we are & how we became your number
                    one supplier of independent & regional cinema movie tickets. Discover ${brand}'s
                    entire history today!` } />
                <link rel="canonical" href={`${window.location.protocol }//${ window.location.host}/about`} />
            </Helmet>
            <AboutUsContent />
        </VersionedLayout>
    );
};
export default AboutUsPage;
